module.exports = __webpack_public_path__ + "img/autumn1.b67337db.jpg";